// Reservation token: a permanent, per-booking opaque key.
//
// token = base64url( HMAC-SHA256(secret, booking_id) )
//
// The token carries NO payload (no dates, no guest data, no expiry). The widget
// cannot decode or verify it — it passes the opaque string to a Cloud Function
// (loadBookingByToken / intake_reservation), which resolves the booking_id
// server-side and returns the full booking record from Firestore. All pre-fill
// data comes from the server; the widget trusts nothing from the token itself.
// Same booking_id → same token, forever (re-quoting never invalidates old links).

export function decodeReservationToken(tokenStr) {
  // The new token is an opaque HMAC of the booking_id. The widget cannot
  // decode it — it passes it to the CF, which resolves it server-side.
  // All pre-fill data comes from the Firestore booking doc loaded by the CF.
  if (!tokenStr) return null;
  return { raw: tokenStr };
}

export function decodeArrivalToken(tokenStr) {
  if (!tokenStr) return null;
  try {
    const json = atob(tokenStr.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(json);
    if (!payload || !payload.bid || !payload.exp) return null;
    if (payload.exp * 1000 < Date.now()) return null;
    return {
      booking_id: payload.bid,
      first_name: payload.fn || "",
      last_name: payload.ln || "",
      email: payload.em || "",
      phone_e164: payload.ph || "",
      checkin_date: payload.ci || "",
      checkout_date: payload.co || "",
      adults: payload.ad || 1,
      children: payload.ch || 0,
      expires_at: payload.exp,
      raw: tokenStr,
    };
  } catch {
    return null;
  }
}
